export class AppSettings {
  constructor(private embedConfig: any) {
    this.embedConfig.minimumAmount = 5;
    this.embedConfig.maximumAmount = 250001;
    if (!this.embedConfig.hosted_url) {
      this.embedConfig.hosted_url = window.location.href;
    }

    // If the gift value can be converted to a number
    // replace the gift in the gift_amounts
    // ["Twenty Five", "25"] => ["Twenty Five", 25]
    if (this.embedConfig['properties']['gift_amounts']) {
      this.embedConfig['properties']['gift_amounts'].forEach((gift, index, gift_amounts) => {
        const giftValue = Number(gift[1]);
        if (giftValue) {
          gift_amounts[index] = [gift[0], giftValue];
        }
      });
    }
  }

  getValue(key: string) {
    return this.embedConfig[key];
  }
}
